import React, { useCallback } from 'react';
import { Modal } from '@vectord/components';

import SuperBatchProjectDetails from '../SuperBatchProjectDetails';

export default function EditSuperBatchProjectModal({
  isOpen,
  setOpen,
  sbatGroup,
  superBatchProjectId,
}) {
  const handleModalClose = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  return (
    <Modal
      className="p-m"
      withoutHeader
      unMountOnClose
      isOpen={isOpen}
      onClose={handleModalClose}
      size="extraLarge"
    >
      <SuperBatchProjectDetails
        handleModalClose={handleModalClose}
        sbatGroup={sbatGroup}
        superBatchProjectId={superBatchProjectId}
      />
    </Modal>
  );
}
